import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, colors } from '@mui/material';
import validate from 'validate.js';
import { FilePicker } from 'components';

import { enqueueSnackbar } from 'actions';
import { SetFormState, GenerateBwScript } from '../../../actions/BwUpdateActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	bwUpdateInput: {
		presence: { allowEmpty: false, message: 'is required' },
	},
};

const BwUpdateForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.bwUpdateReducer.formState.bwUpdate);
	const user = useSelector((state) => state.session.user);

	useEffect(() => {
		const errors = validate(formState.values, schema);
		setFormState({
			bwUpdate: {
				...formState,
				isValid: !errors,
				errors: errors || {},
			}
		});
	}, [formState.values]);

	const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

	const _onChangeInput = (event) => {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			setFormState({
				bwUpdate: {
					...formState,
					values: {
						...formState.values,
						bwUpdateInput: file,
					},
					touched: {
						...formState.touched,
						bwUpdateInput: true,
					},
				}
			});
		}
	};

	const _generate = () => {
		if (formState.values.bwUpdateInput.size > 100000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 100MB', options: { variant: 'warning' } }));
			return;
		}

		dispatch(GenerateBwScript(formState.values.bwUpdateInput, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardHeader title="Required Cell Info" />
			<Divider />
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={4} xs={12}>
						<FilePicker value={formState.values.bwUpdateInput?.name} onChange={_onChangeInput} accept=".zip" />
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Generate</Button>
			</CardActions>
		</Card>
	);
};

export default BwUpdateForm;
